
















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class InputNumberList extends Vue {
  @Prop(Boolean) disabled!: boolean;
  // numberList
  @Prop({ type: Array, default: [] }) numberList!: any[];
  others: any;
  first: any;
  @Watch('numberList')
  onNumberListChanged(val) {
    const { first, others } = this.computeData(val);
    this.first = first;
    this.others = others;
  }

  data() {
    const { first, others } = this.computeData(this.numberList);
    return {
      first,
      others
    };
  }

  private computeData(arr): any {
    try {
      const [first = '', ...others] = arr;
      return {
        first,
        others
      };
    } catch {
      return {
        first: '',
        others: []
      };
    }
  }
  /**
   *  数值变化
   */
  private handleChange(index, v) {
    const arr = Array.from(this.numberList);
    arr[index] = v;
    this.$emit('change', arr);
  }

  private isShowAdd(index, length) {
    if (length === 5 || length - 1 !== index) return false;
    return true;
  }

  private getMin(i) {
    try {
      return Number(this.numberList[i - 1] || 0);
    } catch {
      return 0;
    }
  }

  private addInput() {
    if (this.disabled) return;

    const last = Number(Array.from(this.numberList).pop() || 0);
    const numberList = [this.first, ...this.others, last + 1];

    this.$emit('change', numberList);
  }

  private removeInput(index) {
    if (this.disabled) return;

    this.numberList = this.numberList.filter((it, i) => index !== i);

    this.$emit('change', this.numberList);
  }
}
